var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemPlaneElement_1;
import { CustomElement, P, Watch, PropertyConverters } from '@pacem/pacem-core';
import { Geometry } from '@pacem/pacem-numerical';
import { MeshGeometry } from '../geometry';
import { Pacem3DPrimitiveElement } from './primitive';
import { TAG_MIDDLE_NAME } from '../constants';
//namespace Pacem.Components.Drawing3D {
let PacemPlaneElement = PacemPlaneElement_1 = class PacemPlaneElement extends Pacem3DPrimitiveElement {
    static createMeshGeometry(width, length, widthSegments, lengthSegments) {
        width ||= 1.0;
        length ||= 1.0;
        widthSegments ||= 4;
        lengthSegments ||= 4;
        const halfWidth = width * .5, halfLength = length * .5;
        const nodes = [];
        const uv = [];
        const indices = [];
        const normals = [], normal = Geometry.LinearAlgebra.Vector3D.from(0, 0, 1);
        for (let j = 0; j <= lengthSegments; j++) {
            for (let i = 0; i <= widthSegments; i++) {
                const x = -halfWidth + i * width / (1.0 * widthSegments);
                const y = .0;
                const z = -halfLength + j * length / (1.0 * lengthSegments);
                nodes.push({ x, y, z });
                if (j < lengthSegments && i < widthSegments) {
                    const rowPoints = widthSegments + 1;
                    // const colPoints = lengthSegments + 1;
                    const u_next = (i + 1.0) / (1.0 * widthSegments);
                    const u = (1.0 * i) / (1.0 * widthSegments);
                    const v_next = 1.0 - (j + 1.0) / (1.0 * lengthSegments);
                    const v = 1.0 - (1.0 * j) / (1.0 * lengthSegments);
                    indices.push((j + 1) * rowPoints + i);
                    indices.push((j + 1) * rowPoints + i + 1);
                    indices.push(j * rowPoints + i + 1);
                    indices.push((j + 1) * rowPoints + i);
                    indices.push(j * rowPoints + i + 1);
                    indices.push(j * rowPoints + i);
                    uv.push({ x: u, y: v_next });
                    uv.push({ x: u_next, y: v_next });
                    uv.push({ x: u_next, y: v });
                    uv.push({ x: u, y: v_next });
                    uv.push({ x: u_next, y: v });
                    uv.push({ x: u, y: v });
                    normals.push(normal, normal, normal, normal, normal, normal);
                }
            }
        }
        const geom = new MeshGeometry(nodes, indices, uv, normals);
        geom.key = `plane_${width}x${length}_w${widthSegments}_l${lengthSegments}`;
        // TODO: barycenter, boundingBox, boundingSphere
        return geom;
    }
    createDefaultGeometry() {
        return PacemPlaneElement_1.createMeshGeometry();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'width':
            case 'length':
            case 'widthSegments':
            case 'lengthSegments':
                this.geometry = PacemPlaneElement_1.createMeshGeometry(this.width, this.length, this.widthSegments, this.lengthSegments);
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPlaneElement.prototype, "width", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPlaneElement.prototype, "length", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPlaneElement.prototype, "widthSegments", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemPlaneElement.prototype, "lengthSegments", void 0);
PacemPlaneElement = PacemPlaneElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-primitive-plane' })
], PacemPlaneElement);
export { PacemPlaneElement };
